module.exports = __webpack_public_path__ + "static/media/RecipeApp.53626dd3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/RecipeApp.png
// module id = 37
// module chunks = 0